var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { BookmarkService } from 'app/services/bookmark.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { UserService } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';
var FeatMapBookmarkManagerComponent = /** @class */ (function () {
    function FeatMapBookmarkManagerComponent(toastr, bookmarkService, floatPopupService, mapService, userService) {
        this.toastr = toastr;
        this.bookmarkService = bookmarkService;
        this.floatPopupService = floatPopupService;
        this.mapService = mapService;
        this.userService = userService;
        this.bookmarkList = [];
    }
    FeatMapBookmarkManagerComponent.prototype.close = function () {
        this.floatPopupService.closePopup(FeatMapBookmarkManagerComponent);
    };
    FeatMapBookmarkManagerComponent.prototype.goToBookmark = function (bookmark) {
        this.mapService.map.zoomToExtent(bookmark.bbox, {
            padding: [0, 0, 0, 0]
        });
    };
    FeatMapBookmarkManagerComponent.prototype.getBookmarks = function () {
        return __awaiter(this, void 0, void 0, function () {
            var bookmarks;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookmarkService.getMapBookmarks('BBOX')];
                    case 1:
                        bookmarks = _a.sent();
                        this.bookmarkList = bookmarks;
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatMapBookmarkManagerComponent.prototype.addBookmark = function () {
        return __awaiter(this, void 0, void 0, function () {
            var bbox, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isAdding = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        bbox = this.mapService.map.olMap.getView().calculateExtent();
                        return [4 /*yield*/, this.bookmarkService.addMapBookmarks(this.bookmarkName, this.bookmarkDesc, this.bookmarkVisib, 'BBOX', bbox)];
                    case 2:
                        _a.sent();
                        this.toastr.success('Successfully added');
                        this.bookmarkName = null;
                        this.bookmarkDesc = null;
                        return [4 /*yield*/, this.getBookmarks()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.isAdding = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatMapBookmarkManagerComponent.prototype.deleteBookmark = function (bookmark) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.deletingId = bookmark.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.bookmarkService.deleteMapBookmark(bookmark.id)];
                    case 2:
                        _a.sent();
                        this.toastr.success('Successfully deleted');
                        return [4 /*yield*/, this.getBookmarks()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 5];
                    case 5:
                        this.deletingId = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatMapBookmarkManagerComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.columns = [
                            {
                                prop: 'search',
                                name: ' ',
                                info: {
                                    fixedCellClass: []
                                },
                                // cellTemplate: this.searchCellTempl,
                                width: 30
                            },
                            {
                                prop: 'name',
                                name: 'NAME',
                                info: {
                                    fixedCellClass: []
                                }
                            },
                            // {
                            // 	prop: 'desc',
                            // 	name: 'Description',
                            // 	info: {
                            // 		fixedCellClass: []
                            // 	}
                            // },
                            {
                                prop: 'ownerDisplay',
                                name: 'OWNER',
                                info: {
                                    fixedCellClass: []
                                }
                            },
                            {
                                prop: 'visibility',
                                name: 'VISIBILITY',
                                info: {
                                    fixedCellClass: []
                                }
                            },
                            {
                                prop: 'delete',
                                name: ' ',
                                info: {
                                    fixedCellClass: []
                                },
                                // cellTemplate: this.deleteCellTempl,
                                width: 30
                            }
                        ];
                        this.bookmarkVisibilities = this.bookmarkService.bookmarkVisibilities;
                        this.bookmarkVisib = this.bookmarkVisibilities[0].value;
                        this.userName = this.userService.getUserInfo().userEmail;
                        return [4 /*yield*/, this.getBookmarks()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatMapBookmarkManagerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.bookmarkBboxStr = JSON.stringify(this.mapService.map.olMap.getView().calculateExtent());
        this.mapSub = this.mapService.mapMoveendSubject.subscribe(function () {
            _this.bookmarkBboxStr = JSON.stringify(_this.mapService.map.olMap.getView().calculateExtent());
        });
    };
    FeatMapBookmarkManagerComponent.prototype.ngOnDestroy = function () {
        this.mapSub.unsubscribe();
    };
    return FeatMapBookmarkManagerComponent;
}());
export { FeatMapBookmarkManagerComponent };
